export enum NftType {
  Content = 'content',
  Service = 'service',
  Experience = 'experience',
  Merch = 'merch',
}
